import React from 'react'
import { twMerge } from 'tailwind-merge'

import CoversContainer, {
  CoversContainerExpanded,
} from '../../components/quotation/pricing/CoversContainer'
import { useQuotation } from '../context'

import { OnboardingTitle } from './OnboardingTitle'
import { PricingMREAcheelCoversOptions } from './PricingMREAcheelCoversOptions'

type Props = React.PropsWithChildren & {
  className?: string
  extended?: boolean
  displayOnlyCover?: boolean
}

export const PricingMREAcheelCoversSection = React.forwardRef<HTMLElement, Props>(
  ({ className, extended, displayOnlyCover }, ref) => {
    const { quotation } = useQuotation()

    const details = quotation.details.mreAcheel

    const Container = extended ? CoversContainerExpanded : CoversContainer

    return (
      <section className={twMerge('w-full', className)} id="covers" ref={ref}>
        <Container deductible={details?.deductibleAmount || 0}>
          {displayOnlyCover && <OnboardingTitle.H3>Votre couverture</OnboardingTitle.H3>}

          <PricingMREAcheelCoversOptions displayOnlyCover={displayOnlyCover} />
        </Container>
      </section>
    )
  }
)
